import _extends from '@babel/runtime/helpers/extends';
import _jsx from '@babel/runtime/helpers/jsx';
import React, { useContext, useState, useRef, useEffect } from 'react';
import { getPatchedI18n, AndesContext } from '@andes/context';
import classNames from 'classnames';
import isWebviewIOSOs from '@andes/common/build/utils/isWebviewIOS';
import { Button } from '@andes/button';
import Close24 from '@andes/icons/Close24';
import writeToClipBoard from '@andes/common/build/utils/writeToClipboard';
import { Pill } from '@andes/badge';
import { VisuallyHidden } from '@andes/common';
import Copy16 from '@andes/icons/Copy16';
import { Snackbar } from '@andes/snackbar';
import { Text, Title } from '@andes/typography';
import FeedbackNegative40 from '@andes/icons/FeedbackNegative40';
import { Thumbnail } from '@andes/thumbnail';
const namespace = 'andes-technical-error';
var module$2 = "@andes/technical-error";
var locale$2 = "en-US";
var translations$2 = {
  "andes-technical-error\u0004Cerrar": [null, "Close"],
  "andes-technical-error\u0004Código": [null, "Code"],
  "andes-technical-error\u0004Código copiado": [null, "Code copied"],
  "andes-technical-error\u0004Copiar": [null, "Copy"],
  "andes-technical-error\u0004Si el problema persiste, puedes reportarlo en la sección de Ayuda con el siguiente código": [null, "If the problem persists, you can report it in the Help section with the following code"],
  "andes-technical-error\u0004Algo salió mal": [null, "Something went wrong"],
  "andes-technical-error\u0004Estamos trabajando para solucionarlo": [null, "We are working to fix it"],
  "andes-technical-error\u0004¡Parece que no hay internet!": [null, "Looks like there is no internet connection!"],
  "andes-technical-error\u0004Revisa tu conexión para seguir navegando": [null, "Please check your internet connection to continue browsing"]
};
var enTranslations = {
  module: module$2,
  locale: locale$2,
  translations: translations$2
};
var module$1 = "@andes/technical-error";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-technical-error\u0004Cerrar": [null, "Cerrar"],
  "andes-technical-error\u0004Código": [null, "Código"],
  "andes-technical-error\u0004Código copiado": [null, "Código copiado"],
  "andes-technical-error\u0004Copiar": [null, "Copiar"],
  "andes-technical-error\u0004Si el problema persiste, puedes reportarlo en la sección de Ayuda con el siguiente código": [null, "Si el problema persiste, puedes reportarlo en la sección de Ayuda con el siguiente código"],
  "andes-technical-error\u0004Algo salió mal": [null, "Algo salió mal"],
  "andes-technical-error\u0004Estamos trabajando para solucionarlo": [null, "Estamos trabajando para solucionarlo"],
  "andes-technical-error\u0004¡Parece que no hay internet!": [null, "¡Parece que no hay internet!"],
  "andes-technical-error\u0004Revisa tu conexión para seguir navegando": [null, "Revisa tu conexión para seguir navegando"]
};
var esTranslations = {
  module: module$1,
  locale: locale$1,
  translations: translations$1
};
var module = "@andes/technical-error";
var locale = "pt-BR";
var translations = {
  "andes-technical-error\u0004Cerrar": [null, "Fechar"],
  "andes-technical-error\u0004Código": [null, "Código"],
  "andes-technical-error\u0004Código copiado": [null, "Código copiado"],
  "andes-technical-error\u0004Copiar": [null, "Copiar"],
  "andes-technical-error\u0004Si el problema persiste, puedes reportarlo en la sección de Ayuda con el siguiente código": [null, "Se o problema persistir, você pode reportá-lo na seção Ajuda, usando o código a seguir"],
  "andes-technical-error\u0004Algo salió mal": [null, "Ocorreu um erro"],
  "andes-technical-error\u0004Estamos trabajando para solucionarlo": [null, "Estamos trabalhando para resolvê-lo"],
  "andes-technical-error\u0004¡Parece que no hay internet!": [null, "Sem conexão com a internet!"],
  "andes-technical-error\u0004Revisa tu conexión para seguir navegando": [null, "Verifique sua conexão para continuar navegando"]
};
var ptTranslations = {
  module: module,
  locale: locale,
  translations: translations
};
const CloseButton = _ref => {
  let {
    color,
    onClose
  } = _ref;
  const i18n = getPatchedI18n(AndesContext, enTranslations, esTranslations, ptTranslations);
  return /*#__PURE__*/_jsx("button", {
    className: "".concat(namespace, "__close-button"),
    "aria-label": i18n.pgettext(namespace, 'Cerrar'),
    onClick: onClose,
    type: "button"
  }, void 0, /*#__PURE__*/_jsx(Close24, {
    color: color,
    "aria-hidden": true
  }));
};
CloseButton.displayName = 'CloseButton';
var CloseButton$1 = CloseButton;
var _Copy, _Pill;
const ErrorCodeButton = /*#__PURE__*/function () {
  const ErrorCodeButton = _ref => {
    let {
      className,
      errorCode,
      variant = 'screen',
      errorCodeDescription
    } = _ref;
    const {
      device
    } = useContext(AndesContext);
    const isMobile = device === null || device === void 0 ? void 0 : device.mobile;
    const isScreen = variant === 'screen';
    const i18n = getPatchedI18n(AndesContext, enTranslations, esTranslations, ptTranslations);
    const [copyProcess, setCopyProcess] = useState(false);
    const copyTimeout = useRef();
    useEffect(() => () => {
      clearTimeout(copyTimeout.current);
    }, []);
    const errorCodeButtonClassNames = classNames("".concat(namespace, "__code-button"), className, {
      ["".concat(namespace, "__code-button--snackbar")]: !isScreen,
      ["".concat(namespace, "__code-button--copied")]: !isScreen && copyProcess
    });
    const copyCode = async () => {
      if (copyProcess) return;
      await writeToClipBoard(errorCode).catch(error => {
        throw error;
      });
      setCopyProcess(true);
      copyTimeout.current = setTimeout(() => {
        setCopyProcess(false);
      }, 3000);
    };
    const CopyButton = () => /*#__PURE__*/_jsx("button", {
      className: errorCodeButtonClassNames,
      onClick: copyCode,
      "aria-live": isMobile ? 'assertive' : undefined,
      type: "button"
    }, void 0, (!copyProcess || isScreen) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Text, {
      color: isScreen ? 'secondary' : 'inverted',
      size: "xs"
    }, void 0, "".concat(i18n.pgettext(namespace, 'Código'), ":\xA0")), /*#__PURE__*/_jsx(Text, {
      color: isScreen ? 'link' : 'inverted',
      size: "xs",
      className: "".concat(namespace, "__error-code")
    }, void 0, "".concat(errorCode, "\xA0")), /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "__copy-icon-container")
    }, void 0, _Copy || (_Copy = /*#__PURE__*/_jsx(Copy16, {
      "aria-hidden": true
    }))), /*#__PURE__*/_jsx(VisuallyHidden, {}, void 0, i18n.pgettext(namespace, 'Copiar'))), copyProcess && !isScreen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Text, {
      color: isScreen ? 'secondary' : 'primary',
      size: "xs"
    }, void 0, "".concat(i18n.pgettext(namespace, 'Código copiado'), "\xA0")), _Pill || (_Pill = /*#__PURE__*/_jsx(Pill, {
      contentType: "icon",
      color: "green",
      size: "small"
    }))));
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(Text, {
      className: "".concat(namespace, "__code-text"),
      color: isScreen ? 'secondary' : 'inverted',
      size: "xs",
      component: "p"
    }, void 0, errorCodeDescription || "".concat(i18n.pgettext(namespace, 'Si el problema persiste, puedes reportarlo en la sección de Ayuda con el siguiente código'), ":")), /*#__PURE__*/_jsx(CopyButton, {}), isScreen && /*#__PURE__*/_jsx(Snackbar, {
      show: copyProcess,
      message: i18n.pgettext(namespace, 'Código copiado'),
      color: "green",
      delay: 3000
    }));
  };
  ErrorCodeButton.displayName = 'ErrorCodeButton';
  return ErrorCodeButton;
}();
var ErrorCodeButton$1 = ErrorCodeButton;
const ErrorScreen = _ref => {
  var _FeedbackNegative;
  let {
    action,
    asset: Illustration,
    className,
    closable = false,
    description,
    errorCode,
    onClose,
    title,
    errorCodeDescription
  } = _ref;
  const andesGray550 = 'rgba(0, 0, 0, 0.55)';
  const {
    device
  } = useContext(AndesContext);
  const isMobile = device === null || device === void 0 ? void 0 : device.mobile;
  const isWebviewIOS = isWebviewIOSOs(device);
  const containerClassNames = classNames(className, "".concat(namespace, "__container"), {
    ["".concat(namespace, "__container--webview-ios")]: isWebviewIOS
  });
  const assetContainerClassNames = classNames("".concat(namespace, "__asset-container"), {
    ["".concat(namespace, "__asset-container--illustration")]: Illustration
  });
  const NoneAssetIcon = () => /*#__PURE__*/_jsx(Thumbnail, {
    className: "".concat(namespace, "__none-asset-icon"),
    size: "64"
  }, void 0, _FeedbackNegative || (_FeedbackNegative = /*#__PURE__*/_jsx(FeedbackNegative40, {
    color: andesGray550,
    "aria-hidden": true
  })));
  return /*#__PURE__*/_jsx("div", {
    className: containerClassNames
  }, void 0, isMobile && closable && /*#__PURE__*/_jsx(CloseButton$1, {
    color: andesGray550,
    onClose: onClose
  }), /*#__PURE__*/_jsx("div", {
    className: assetContainerClassNames
  }, void 0, Illustration || /*#__PURE__*/_jsx(NoneAssetIcon, {})), /*#__PURE__*/_jsx(Title, {
    className: "".concat(namespace, "__title"),
    component: "h2"
  }, void 0, title), description && /*#__PURE__*/_jsx(Text, {
    className: "".concat(namespace, "__description")
  }, void 0, description), errorCode && /*#__PURE__*/_jsx(ErrorCodeButton$1, {
    errorCode: errorCode,
    errorCodeDescription: errorCodeDescription
  }), action && /*#__PURE__*/_jsx(Button, {
    className: "".concat(namespace, "__action-button"),
    hierarchy: "transparent",
    onClick: action.onClick,
    href: action.href,
    target: action.target,
    rel: action.rel
  }, void 0, action.text));
};
ErrorScreen.displayName = 'ErrorScreen';
var ErrorScreen$1 = ErrorScreen;
const Base = props => {
  const i18n = getPatchedI18n(AndesContext, enTranslations, esTranslations, ptTranslations);
  return /*#__PURE__*/React.createElement(ErrorScreen$1, _extends({}, props, {
    description: "".concat(i18n.pgettext(namespace, 'Estamos trabajando para solucionarlo'), "."),
    title: i18n.pgettext(namespace, 'Algo salió mal')
  }));
};
var Base$1 = Base;
var _g, _defs;
const Asset = _ref => {
  let {
    srLabel
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    "aria-hidden": srLabel ? undefined : !srLabel,
    "aria-label": srLabel || undefined,
    role: srLabel ? 'img' : undefined,
    width: "320",
    height: "128",
    viewBox: "0 0 320 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, srLabel && /*#__PURE__*/_jsx("title", {}, void 0, srLabel), _g || (_g = /*#__PURE__*/_jsx("g", {
    clipPath: "url(#clip0_1811_84641)"
  }, void 0, /*#__PURE__*/_jsx("rect", {
    width: "320",
    height: "128",
    fill: "none"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.162 5.05468C179.441 3.28901 164.364 6.08194 154.657 14.8924C143.999 24.5625 135.494 30.3302 123.748 33.3933C112.533 36.3209 91.4712 36.7486 80.2281 50.5405C66.2277 67.7131 75.4886 89.8215 95.4386 104.355C117.732 120.598 160.103 136.09 198.294 121.577C235.635 107.386 244.506 73.4254 240.39 53.0161C234.684 24.717 209.571 7.4684 192.162 5.05468",
    fill: "black",
    fillOpacity: "0.04"
  }), /*#__PURE__*/_jsx("rect", {
    x: "99.2554",
    y: "15.5566",
    width: "127.241",
    height: "97.2863",
    rx: "5",
    fill: "white"
  }), /*#__PURE__*/_jsx("path", {
    d: "M100.755 32.5708H224.997V107.843C224.997 109.776 223.43 111.343 221.497 111.343H104.255C102.322 111.343 100.755 109.776 100.755 107.843V32.5708Z",
    fill: "#EEEEEE",
    stroke: "white",
    strokeWidth: "3"
  }), /*#__PURE__*/_jsx("path", {
    d: "M99.2554 89.5642V20.5566C99.2554 17.7952 101.494 15.5566 104.255 15.5566H221.497C224.258 15.5566 226.497 17.7952 226.497 20.5566V42.8142M99.2554 93.5642V94.2485V98.2485V107.843C99.2554 110.604 101.494 112.843 104.255 112.843H221.497C224.258 112.843 226.497 110.604 226.497 107.843V60.2485V56.2485V53.6892M226.497 46.9064V49.2485V49.8767",
    stroke: "#333333",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_jsx("path", {
    d: "M99.2554 31.0708H226.497",
    stroke: "#333333",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_jsx("ellipse", {
    cx: "106.532",
    cy: "23.4278",
    rx: "1.37345",
    ry: "1.37236",
    fill: "#333333"
  }), /*#__PURE__*/_jsx("ellipse", {
    cx: "113.857",
    cy: "23.4278",
    rx: "1.37345",
    ry: "1.37236",
    fill: "#333333"
  }), /*#__PURE__*/_jsx("ellipse", {
    cx: "121.182",
    cy: "23.4278",
    rx: "1.37345",
    ry: "1.37236",
    fill: "#333333"
  }), /*#__PURE__*/_jsx("path", {
    d: "M165.882 58.1767L178.608 77.7748C180.092 80.0613 178.451 83.0834 175.725 83.0834H150.273C147.547 83.0834 145.906 80.0613 147.391 77.7748L160.117 58.1767C161.472 56.0898 164.526 56.0898 165.882 58.1767Z",
    fill: "white",
    stroke: "white",
    strokeWidth: "3"
  }), /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.859 57.3598C160.805 54.3621 165.193 54.3621 167.14 57.3598L179.866 76.9579C181.998 80.2423 179.641 84.5834 175.725 84.5834H150.273C146.357 84.5834 144 80.2423 146.133 76.9579L158.859 57.3598Z",
    stroke: "#333333",
    strokeWidth: "1.5"
  }), /*#__PURE__*/_jsx("path", {
    d: "M164.599 64.583H161.399L161.799 73.383H164.199L164.599 64.583Z",
    fill: "#333333"
  }), /*#__PURE__*/_jsx("path", {
    d: "M162.999 74.983C163.883 74.983 164.599 75.6994 164.599 76.583C164.599 77.4667 163.883 78.183 162.999 78.183C162.116 78.183 161.399 77.4667 161.399 76.583C161.399 75.6994 162.116 74.983 162.999 74.983Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/_jsx("defs", {}, void 0, /*#__PURE__*/_jsx("clipPath", {
    id: "clip0_1811_84641"
  }, void 0, /*#__PURE__*/_jsx("rect", {
    width: "320",
    height: "128",
    fill: "white"
  })))));
};
var PaginaNoEncontrada = Asset;
var _PaginaNoEncontrada;
const Error404 = props => /*#__PURE__*/React.createElement(Base$1, _extends({}, props, {
  asset: _PaginaNoEncontrada || (_PaginaNoEncontrada = /*#__PURE__*/_jsx(PaginaNoEncontrada, {}))
}));
export { Error404 as default };
